import type {FC} from 'react';
import CenteredLayout from '@/components/Layouts/CenteredLayout';
import FullScreenWrapper from '@/components/Layouts/FullScreenWrapper';
import LoginForm from '@/components/Login/LoginForm';
import {useController} from './controller';

const LoginView: FC = () => {
  const {user, pass, errors, onUsernameChange, onPasswordChange, onLogin, isLoading} = useController();

  return (
    <FullScreenWrapper>
      <CenteredLayout>
        <LoginForm
          password={pass}
          username={user}
          loginErrorMessage={errors}
          isLoading={isLoading}
          onLoginButtonClicked={onLogin}
          onUsernameChanged={onUsernameChange}
          onPasswordChanged={onPasswordChange}
        />
      </CenteredLayout>
    </FullScreenWrapper>
  );
};

export default LoginView;
